<template>
  <div class="clazz-chart">
    <div class="chart-title" v-if="clazz">
      <template v-if="!hideTitle">
        {{ clazz.name }}
      </template>
      <small class="s-time" v-if="clazz.lastStatTime">
        统计时间：{{ clazz.lastStatTime | formatDatetime }}
      </small>
    </div>
    <div class="sys-info" v-if="message">
      {{ message }}
    </div>
    <v-card class="panel chart-train-summary" style="width:100%"
      v-if="!hideClazzSummary && !hideStuSummary && summaries">
      <div class="chart-summary-title">培训概况</div>
      <v-layout row wrap>
        <v-flex md2 xm6 v-for="summary in summaries" :key="summary.l">
          <div class="chart-summary">
            <v-card :color="summary.c" dark>
              <v-card-text>
                <span class="summary-value">
                  <em>{{ summary.v }}</em>
                </span>
                <span class="summary-title">{{ summary.l }}</span>
              </v-card-text>
            </v-card>
          </div>
        </v-flex>
      </v-layout>
      <v-divider class="mt-2 mb-2" />
      <v-layout row wrap>
        <v-flex md4 xm12 v-if="summary && passPercentSummary">
          <div class="chart-pie">
            <v-layout row>
              <v-flex md4>
                <v-chart class="v-chart" autoresize :option="passPercentSummary" />
              </v-flex>
              <v-flex md8 class="content" style="padding-top: 10px">
                <div class="emphasize" :style="{ color: passPercentSummary.color[0] }">
                  <v-icon :color="passPercentSummary.color[0]" small>stop</v-icon>
                  通过人数: {{ Math.max(0, summary.passCount - (summary.resignPassCount || 0)) }}
                </div>
                <div class="emphasize" :style="{ color: passPercentSummary.color[1] }">
                  <v-icon :color="passPercentSummary.color[1]" small>stop</v-icon>
                  选课人数: {{ Math.max(0, summary.stuCount - (summary.resignStuCount || 0)) }}
                </div>
                <div class="normal">不包括离职人员统计</div>
              </v-flex>
            </v-layout>
          </div>
        </v-flex>
        <v-flex md4 xm12 v-if="summary && passCountSummary">
          <div class="chart-pie">
            <v-layout row>
              <v-flex md4>
                <v-chart class="v-chart" autoresize :option="passCountSummary" />
              </v-flex>
              <v-flex class="content" style="padding-top: 10px" md8>
                <div class="emphasize" :style="{ color: passCountSummary.color[0] }">
                  <v-icon :color="passCountSummary.color[0]" small>stop</v-icon>
                  通过人数: {{ summary.passCount + (summary.resignPassCount > 0 ? `(${summary.resignPassCount}离职)` : '') }}
                </div>
                <div class="emphasize" :style="{ color: passCountSummary.color[1] }">
                  <v-icon :color="passCountSummary.color[1]" small>stop</v-icon>
                  未学习人数: {{ summary.unlearnStuCount }}(包含离职)
                </div>
                <div class="normal">选课人数: {{ summary.stuCount + (summary.resignStuCount > 0 ?
      `(${summary.resignStuCount}离职)` : '') }}</div>
              </v-flex>
            </v-layout>
          </div>
        </v-flex>
        <v-flex md4 xm12 v-if="summary && stuCountSummary">
          <div class="chart-pie">
            <v-layout row>
              <v-flex md4>
                <v-chart class="v-chart" autoresize :option="stuCountSummary" />
              </v-flex>
              <v-flex class="content" style="padding-top: 10px" md8>
                <div class="emphasize" :style="{ color: stuCountSummary.color[0] }">
                  <v-icon :color="stuCountSummary.color[0]" small>stop</v-icon>
                  选课人数: {{ summary.stuCount + (summary.resignStuCount > 0 ? `(${summary.resignStuCount}离职)` : '') }}
                </div>
                <div class="normal">总人数: {{ summary.totalStuCount || 0 }}</div>
              </v-flex>
            </v-layout>
          </div>
        </v-flex>
        <v-flex md4 xm12 v-if="summary && tagSummary">
          <div class="chart-pie">
            <v-layout row>
              <v-flex md4>
                <v-chart class="v-chart" autoresize :option="tagSummary" />
              </v-flex>
              <v-flex class="content" style="padding-top: 10px" md8>
                <div v-for="(item, index) in tagSummary.series[0].data" :key="item.name" class="emphasize"
                  :style="{ color: tagSummary.color[index] }">
                  <v-icon :color="tagSummary.color[index]" small>stop</v-icon>
                  {{ item.name }}: {{ item.value }}
                </div>
              </v-flex>
            </v-layout>
          </div>
        </v-flex>
      </v-layout>
    </v-card>
    <v-card class="panel" v-if="!hideStepSummary && progresses">
      <v-card-text>
        <div class="chart-summary-title">按学习模块统计</div>
        <v-layout row wrap v-if="quizPassTryCount">
          <v-flex md6 sm12 class="pa-1">
            <v-chart autoresize :option="progresses" class="chart-progress" />
          </v-flex>
          <v-flex md6 sm12 class="pa-1">
            <v-chart autoresize :option="quizPassTryCount" class="chart-progress" />
          </v-flex>
        </v-layout>
        <v-chart class="chart-progress" v-else autoresize :option="progresses" />
      </v-card-text>
    </v-card>
    <v-card class="panel chart-table" v-if="!hideOrgList && orgData">
      <div style="text-align: right; padding: 8px 20px">
        <a :href="exportUrl" target="_blank">导出表格</a>
      </div>
      <v-data-table :headers="orgSummaryHeader" :items="orgData" light
        :rows-per-page-items="[20, 50, 100, { text: '全部', value: -1 }]">
        <template v-slot:items="props">
          <td v-for="h in orgSummaryHeader" :key="h.text" :style="{ 'text-align': h.align }">
            {{ props.item[h.value] || 0 }}
          </td>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<script>
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { PieChart, BarChart, LineChart } from "echarts/charts";
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  ToolboxComponent,
  MarkLineComponent,
  MarkPointComponent,
} from "echarts/components";
import VChart from "vue-echarts";

use([
  CanvasRenderer,
  PieChart,
  BarChart,
  LineChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  ToolboxComponent,
  MarkLineComponent,
  MarkPointComponent,
]);

export default {
  components: {
    "v-chart": VChart,
  },
  props: {
    clazzId: Number,
    hideOrgList: Boolean,
    hideStuSummary: Boolean,
    hideClazzSummary: Boolean,
    hideStepSummary: Boolean,
    hideTitle: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      clazz: null,
      summaries: null,
      summary: null,
      stuCountSummary: null,
      passCountSummary: null,
      passPercentSummary: null,
      tagSummary: null,
      progresses: null,
      orgSummaryHeader: [],
      orgData: null,
      exportUrl: "",
      message: null,
      quizPassTryCount: null,
      colors: this.$colors
    };
  },
  methods: {
    init() {
      let self = this,
        clazzId = self.clazzId || self.$route.params._clazzId, colors = self.colors;
      if (!clazzId) {
        return;
      }
      self.message = '加载中...';
      self.$axios
        .get(`/home/admin/my/tenant/clazz/stats/summary/${clazzId}`)
        .then((r) => {
          if (r.data && r.data.status == "ok") {
            let clazz = r.data.message;

            let summary = clazz;
            if (r.data.summary) {
              summary = r.data.summary;
            }

            self.clazz = clazz;

            if (!summary.stuCount) {
              self.message = "该班级没有学员";
              return;
            }

            self.message = null;
            self.summary = summary;

            let summaries = [
              {
                l: "总人数",
                v: summary.totalStuCount,
                c: colors[0],
                p: 100,
                i: "group",
              },
              {
                l: "选课人数",
                v: summary.stuCount + (summary.resignStuCount > 0 ? `(${summary.resignStuCount}离职)` : ''),
                c: colors[1],
                i: "developer_board",
              },
              {
                l: "通过人数",
                v: summary.passCount + (summary.resignPassCount > 0 ? `(${summary.resignPassCount}离职)` : ''),
                c: colors[2],
                i: "check",
              },
            ];
            if (summary.noSignCount > 0) {
              summaries.push({
                l: "未签字数",
                v: summary.noSignCount,
                c: colors[3],
                i: "brush",
              });
            }

            self.stuCountSummary = {
              tooltip: {
                show: true,
              },
              legend: {
                show: false,
              },
              color: colors,
              series: [
                {
                  type: "pie",
                  radius: ["70%", "90%"],
                  label: {
                    show: true,
                    position: "center",
                    formatter(params) {
                      return params.seriesIndex === 0
                        ? [
                          "{l|选课率}",
                          "{v|" +
                          ((summary.totalStuCount || 0) === 0
                            ? 0
                            : Math.min(100, (
                              ((summary.stuCount || 0) * 100) /
                              summary.totalStuCount
                            ).toFixed(0))) +
                          "%}",
                        ].join("\n")
                        : "";
                    },
                    rich: {
                      l: {
                        /*color: "#909399",*/
                        lineHeight: 16,
                        fontSize: 8,
                      },
                      v: {
                        fontSize: 12,
                      },
                    },
                  },
                  labelLine: { show: false },
                  data: [
                    { value: summary.stuCount, name: "选课人数" },
                    {
                      value: summary.totalStuCount - summary.stuCount,
                      label: { show: false },
                      name: "其他人数",
                    },
                  ],
                },
              ],
            };

            self.passCountSummary = {
              tooltip: {
                show: true,
              },
              legend: {
                show: false,
              },
              color: colors,
              series: [
                {
                  type: "pie",
                  radius: ["70%", "90%"],
                  label: {
                    show: true,
                    position: "center",
                    formatter(params) {
                      return params.seriesIndex === 0
                        ? [
                          "{l|通过率}",
                          "{v|" +
                          ((summary.stuCount || 0) === 0
                            ? 0
                            : Math.min(100, (
                              ((summary.passCount || 0) * 100) /
                              summary.stuCount
                            ).toFixed(0))) +
                          "%}",
                        ].join("\n")
                        : "";
                    },
                    rich: {
                      l: {
                        /*color: "#909399",*/
                        lineHeight: 16,
                        fontSize: 8,
                      },
                      v: {
                        fontSize: 12,
                      },
                    },
                  },
                  labelLine: { show: false },
                  data: [
                    { value: summary.passCount, name: "通过人数" },
                    {
                      value: summary.unlearnStuCount,
                      name: "未学习人数（包含离职）",
                      label: { show: false },
                    },
                    {
                      value:
                        summary.stuCount -
                        summary.unlearnStuCount -
                        summary.passCount,
                      label: { show: false },
                      name: "其他人数",
                    },
                  ],
                },
              ],
            };

            self.passPercentSummary = {
              tooltip: {
                show: true,
              },
              legend: {
                show: false,
              },
              color: colors,
              series: [
                {
                  type: "pie",
                  radius: ["70%", "90%"],
                  label: {
                    show: true,
                    position: "center",
                    formatter(params) {
                      return params.seriesIndex === 0
                        ? [
                          "{l|通过率}",
                          "{v|" +
                          (Math.max(0, summary.stuCount - (summary.resignStuCount || 0)) === 0
                            ? 0
                            : Math.min(100, (
                              (Math.max(0, summary.passCount - (summary.resignPassCount || 0)) * 100) /
                              Math.max(0, summary.stuCount - (summary.resignStuCount || 0))
                            ).toFixed(0))) +
                          "%}",
                        ].join("\n")
                        : "";
                    },
                    rich: {
                      l: {
                        /*color: "#909399",*/
                        lineHeight: 16,
                        fontSize: 8,
                      },
                      v: {
                        fontSize: 12,
                      },
                    },
                  },
                  labelLine: { show: false },
                  data: [
                    { value: Math.max(0, summary.passCount - (summary.resignPassCount || 0)), name: "通过人数" },
                    {
                      value: Math.max(0, summary.stuCount - (summary.resignStuCount || 0) - Math.max(0, summary.passCount - (summary.resignPassCount || 0))),
                      name: "未通过人数",
                      label: { show: false },
                    }
                  ],
                },
              ],
            };

            if (summary.tagStuCount) {
              let tagSummary = {
                tooltip: {
                  show: true,
                },
                legend: {
                  show: false,
                },
                color: colors,
                series: [
                  {
                    type: "pie",
                    radius: ["70%", "90%"],
                    label: {
                      show: true,
                      position: "center",
                      formatter(params) {
                        return params.seriesIndex === 0
                          ? [
                            "{l|特殊状态}",
                            "{v|" + summary.tagStuCount + "}",
                          ].join("\n")
                          : "";
                      },
                      rich: {
                        l: {
                          /*color: "#909399",*/
                          lineHeight: 16,
                          fontSize: 8,
                        },
                        v: {
                          fontSize: 12,
                        },
                      },
                    },
                    labelLine: { show: false },
                    data: [],
                  },
                ],
              };
              let tagHash = {},
                tags = summary.tagHash ? JSON.parse(summary.tagHash) : {};
              for (let t of r.data.tags) {
                tagHash[t.id] = t.name;
              }

              for (let k in tags) {
                let tag = tagHash[k];
                if (tag) {
                  tagSummary.series[0].data.push({
                    name: tag,
                    value: tags[k],
                  });
                }
              }
              self.tagSummary = tagSummary;
            }

            //各个板块的学习进度
            let rule = r.data.rule, barCommons = {
              barMaxWidth: 20, type: 'bar', itemStyle: {
                borderRadius: [10, 10, 0, 0]
              }
            },
              categories = [],
              progresses = [
                {
                  name: "<25%",
                  data: [],
                  ...barCommons
                },
                {
                  name: "<50%",
                  data: [],
                  ...barCommons
                },
                {
                  name: "<75%",
                  data: [],
                  ...barCommons
                },
                {
                  name: "<100%",
                  data: [],
                  ...barCommons
                },
                {
                  name: "100%",
                  data: [],
                  ...barCommons
                },
              ],
              avgProgresses = [];
            if (rule.reqNum) {
              categories.push("必学");
              avgProgresses.push(summary.reqProgress);
              let hash = {};
              if (summary.reqProgressHash) {
                hash = JSON.parse(summary.reqProgressHash);
              }
              for (let i = 0; i < progresses.length; i++) {
                let v = hash[i],
                  p = progresses[i];
                p.data.push({
                  value: v || 0
                });
              }
              summaries.push({
                l: "必学完成人数",
                c: colors[6],
                i: "brush",
                v: hash[4] || 0
              });
            }
            if (rule.optNum) {
              categories.push("选学");
              avgProgresses.push(summary.optProgress);
              let hash = {};
              if (summary.optProgressHash) {
                hash = JSON.parse(summary.optProgressHash);
              }
              for (let i = 0; i < progresses.length; i++) {
                let v = hash[i],
                  p = progresses[i];
                p.data.push({
                  value: v || 0
                });
              }
            }
            if (rule.quizNum) {
              categories.push("考试");
              avgProgresses.push(summary.quizProgress);
              let hash = {};
              if (summary.quizProgressHash) {
                hash = JSON.parse(summary.quizProgressHash);
              }
              for (let i = 0; i < progresses.length; i++) {
                let v = hash[i],
                  p = progresses[i];
                p.data.push({
                  value: v || 0
                });
              }
              summaries.push({
                l: "考试通过人数",
                c: colors[4],
                i: "brush",
                v: hash[4] || 0
              });


              if (summary.quizPassTryCountHash) {
                let quizPassTryCountHash = {};
                //let tmp = { 1: { A: 30, B: 5, C: 50 }, 2: { A: 9, B: 20, C: 10 } };
                let tmp = JSON.parse(summary.quizPassTryCountHash);
                //如果有多个考试直接合并一下
                for (let o in tmp) {
                  o = tmp[o];
                  for (let k in o) {
                    quizPassTryCountHash[k] = (quizPassTryCountHash[k] || 0) + o[k];
                  }
                }
                self.quizPassTryCount = {
                  tooltip: { trigger: "axis" },
                  title: {
                    subtext: "考试通过尝试次数分布"
                  },
                  toolbox: {
                    show: true,
                    feature: {
                      saveAsImage: { show: true },
                    },
                  },
                  xAxis: {
                    type: "category",
                    data: ["尝试1次", "尝试2-5次", "尝试大于5次"],
                  },
                  yAxis: {
                    type: "value",
                  },
                  series: [{
                    ...barCommons, name: '人数', data: [
                      { value: quizPassTryCountHash['A'] || 0, color: colors[3] },
                      { value: quizPassTryCountHash['B'] || 0, color: colors[4] },
                      { value: quizPassTryCountHash['C'] || 0, color: colors[5] }
                    ]
                  }]
                }
              }
            }

            if (self.clazz.readCount) {
              categories.push("阅读");
              avgProgresses.push(summary.readProgress);
              let hash = {};
              if (summary.readProgressHash) {
                hash = JSON.parse(summary.readProgressHash);
              }
              for (let i = 0; i < progresses.length; i++) {
                let v = hash[i],
                  p = progresses[i];
                p.data.push({
                  value: v || 0
                });
              }
              summaries.push({
                l: "阅读完成人数",
                c: colors[5],
                i: "brush",
                v: hash[4] || 0
              });
            }

            if (self.clazz.faceRecog) {
              categories.push("人脸");
              avgProgresses.push(summary.faceProgress);
              let hash = {};
              if (summary.faceProgressHash) {
                hash = JSON.parse(summary.faceProgressHash);
              }
              for (let i = 0; i < progresses.length; i++) {
                let v = hash[i],
                  p = progresses[i];
                p.data.push({
                  value: v || 0
                });
              }
            }

            self.progresses = {
              tooltip: { trigger: "axis" },
              title: {
                subtext: "各模块进度分布"
              },
              toolbox: {
                show: true,
                feature: {
                  saveAsImage: { show: true },
                },
              },
              legend: {
                show: true,
                data: ["<25%", "<50%", "<75%", "<100%", "100%"],
                y: "bottom",
                padding: [0, 0, 10, 0]
              },
              xAxis: {
                type: "category",
                data: categories,
              },
              yAxis: {
                type: "value",
              },
              series: progresses,
            };
            self.summaries = summaries;
            //机构的列表
            if (r.data.orgs) {
              let header = [
                { text: "机构(按照组织结构用'-'隔开显示）", value: "orgName" },
                { text: "总人数", value: "totalStuCount", align: "right" },
                { text: "学习人数", value: "stuCount", align: "right" },
                { text: "离职学习人数", value: 'resignStuCount', align: 'right' },
                { text: "通过人数", value: "passCount", align: "right" },
                { text: "离职通过人数", value: "resignPassCount", align: "right" },
                { text: "未学人数", value: "unlearnStuCount", align: "right" },
                { text: "标记人数", value: "tagStuCount", align: "right" },
              ];
              if (rule.reqNum) {
                header.push({
                  text: "必学平均进度",
                  value: "reqProgress",
                  align: "right",
                });
              }
              if (rule.optNum) {
                header.push({
                  text: "选学平均进度",
                  value: "optProgress",
                  align: "right",
                });
              }
              if (rule.quizNum) {
                header.push({
                  text: "考试平均进度",
                  value: "quizProgress",
                  align: "right",
                });
              }
              if (self.clazz.readCount) {
                header.push({
                  text: "阅读平均进度",
                  value: "readProgress",
                  align: "right",
                });
              }
              if (self.clazz.faceRecog) {
                header.push({
                  text: "人脸平均通过率",
                  value: "faceProgress",
                  align: "right",
                });
              }

              self.orgSummaryHeader = header;

              let orgData = [],
                orgHash = {};
              if (r.data.summaries) {
                for (let o of r.data.summaries) {
                  orgHash[o.orgId] = o;
                }
              }

              for (let org of r.data.orgs) {
                let tmp = orgHash[org.id];
                tmp = tmp || {};
                tmp.orgName = org.name;
                tmp.orgId = org.id;
                orgData.push(tmp);
              }
              self.orgData = orgData;
              self.exportUrl =
                self.$const.baseUrl +
                `/home/admin/my/tenant/clazz/stats/summaries/export/${clazzId}.xlsx`;
            } else {
              self.orgData = null;
            }
          }
          self.message = null;
        });
    },
  },
  created() {
    this.init();
  },
};
</script>
<style scoped>
.echarts {
  width: 100%;
  height: 100%;
}

.chart-title {
  font-size: 16px;
}

.chart-summary {
  padding: 4px;
}

.chart-summary .summary-title {
  font-size: 12px;
  margin-left: 4px;
}

.chart-summary .summary-value {
  font-size: 18px;
  line-height: 40px;
  font-weight: bold;
}

.chart-summary-title {
  margin-bottom: 8px;
}

.chart-train-summary {
  display: inline-block;
  padding: 16px;
  margin-right: 8px;
}

.chart-train-summary .chart-pie {
  padding: 4px;
}

.chart-train-summary .chart-pie .v-chart {
  height: 80px;
}

.chart-train-summary .chart-pie .content .normal {
  font-size: 10px;
  color: #909399;
  padding-left: 20px;
}

.chart-progress {
  width: 100%;
  height: 250px;
  border: 1px dashed #eee;
}

.panel {
  margin-top: 16px;
  width: 100%;
}

.s-time {
  font-size: 12px;
  color: gray;
}
</style>
